export const saveFcmToken = async (fcmToken: string) => {
    const url = `${process.env.API_BASE_URL}/readInbox/saveFcmToken`;
    const body = JSON.stringify({
        fcmToken,
        Platform: "web",
    });

    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body,
        credentials: "include",
    });

    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
};
